import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { Main, Content, SubContent } from "../../components/Layout";
import { Col, Row } from "react-bootstrap";
import Slct from "../../components/Slct";
import getCommercial from "../../util/getCommercial";
import { InputDocument, IntegerNumber, InputText } from "../../components/Input";
import useWrapper from "../../hooks/useWrapper";
import AttendanceTable from "../../components/AttendanceTable";
import useFormat from "../../hooks/utils/useFormat";
import { toast } from "react-toastify";
import Accordion2 from "../../components/Accordion";
import Button from "../../components/Button";
import { listUsers } from "../../hooks/api/lisUsers";
import Loading from "../../components/Loading";
import SidebarAtendimento from "../../components/SidebarAtendimento";

export default function Attendance() {
  const { setbreadcrumb, config, me } = useWrapper();
  const { formatQuery } = useFormat();

  const [commercials, setcommercials] = useState([]);
  const [attendances, setattendances] = useState();
  const [categories, setcategories] = useState([]);
  const [users, setusers] = useState([]);

  const [isLoadingEssential, setisLoadingEssential] = useState(false);
  const [isLoadingAttendances, setisLoadingAttendances] = useState(false);
  const [isWaitingResponse, setisWaitingResponse] = useState(false);

  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingAttendances);
  }, [isLoadingEssential, isLoadingAttendances]);

  const [filter, setfilter] = useState({});

  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        const _commercials = await getCommercial(null, null, "?is_class=1&joins=institution,course");
        setcommercials(_commercials);
        const { data: _categories } = await api.get("categories?paginate=false", config);
        setcategories(
          _categories.map(__category => ({
            value: __category?.id,
            label: __category?.name,
            resources: __category?.resource?.map(__resource => ({
              value: __resource?.id,
              label: __resource?.name,
            })),
          })),
        );

        const _users = await listUsers({
          config,
          me,
          query: "active=1&paginate=false&joins=null",
        });
        setusers(_users);
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar a lista de Turmas.");
      } finally {
        setisLoadingEssential(false);
        applyFilter(filter);
      }
    })();
    // Run once on mount to load initial filter options and apply the initial filter.
    // `config`/`me` come from context and are recreated on every render, and `applyFilter`
    // closes over `filter`, so adding them here would cause the fetch to loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [query, setquery] = useState();
  const applyFilter = async __filter => {
    document.querySelector("#page-filter .accordion-button[aria-expanded='true']")?.click();
    try {
      setisLoadingAttendances(true);
      let _filter = __filter || filter;
      _filter = {
        ..._filter,
      };
      if (!!__filter) {
        setfilter({
          ...__filter,
          page: 1,
        });
      }
      _filter = {
        ..._filter,
        andamento: _filter?.andamento || "ativo",
        ...(_filter?.status === "urgente" ? { status: undefined, status_urgent: 1 } : {}),
      };
      const _query = formatQuery(_filter);
      setquery(_query);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar pagamentos.");
    } finally {
      setisLoadingAttendances(false);
    }
  };

  useEffect(() => {
    setbreadcrumb([{ label: "Atendimentos" }]);
  }, [setbreadcrumb]);

  return (
    <>
      <Main>
        {!isLoadingEssential ? (
          <Content noBG="true">
            <Row>
              <Col>
                <SubContent>
                  <Row>
                    <Col>
                      <h2 className="mini-title">Atendimentos:</h2>
                      <p className="small-label mb-3">
                        Acompanhe e gerencie os atendimentos registrados. Visualize o status de cada solicitação e
                        assegure um acompanhamento eficiente das interações com os formandos.
                      </p>
                    </Col>
                  </Row>
                  <Accordion2 id="page-filter">
                    <Accordion2.Item eventKey={`page-filter`}>
                      <Accordion2.Header>
                        <span>Filtro</span>
                        <Accordion2.Extras>
                          <span>{attendances?.total} resultados</span>
                        </Accordion2.Extras>
                      </Accordion2.Header>
                      <Accordion2.Body>
                        <Row>
                          <Col sm={2}>
                            <span>Protocolo</span>
                            <IntegerNumber
                              disabled={!!isWaitingResponse}
                              value={filter?.id}
                              valueChange={__ev => {
                                setfilter({
                                  ...filter,
                                  id: __ev,
                                });
                              }}
                            />
                          </Col>
                          <Col sm={5}>
                            <span>Atendente</span>
                            <Slct
                              isDisabled={!!isWaitingResponse}
                              options={[
                                {
                                  value: null,
                                  label: "-- Todos --",
                                },
                              ].concat(users)}
                              placeholder="..."
                              value={filter?.user_id}
                              onChange={__ev => {
                                setfilter({
                                  ...filter,
                                  user_id: __ev.value,
                                });
                              }}
                            />
                          </Col>
                          <Col sm={5}>
                            <span>Turma</span>
                            <Slct
                              isDisabled={!!isWaitingResponse}
                              options={[
                                {
                                  value: null,
                                  label: "-- Todas --",
                                },
                              ].concat(commercials)}
                              placeholder="..."
                              value={filter?.commercial_id}
                              onChange={__ev => {
                                setfilter({
                                  ...filter,
                                  commercial_id: __ev.value,
                                });
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col sm={8}>
                            <span>Nome do Formando</span>
                            <InputText
                              disabled={!!isWaitingResponse}
                              value={filter?.name || ""}
                              onChange={__ev => {
                                setfilter({
                                  ...filter,
                                  name: __ev.target.value,
                                });
                              }}
                            />
                          </Col>
                          <Col sm={4}>
                            <span>CPF do Formando</span>
                            <InputDocument
                              disabled={!!isWaitingResponse}
                              value={filter?.cpf}
                              type="cpf"
                              valueChange={__ev => {
                                setfilter({
                                  ...filter,
                                  cpf: __ev,
                                });
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col sm={6}>
                            <span>Categoria</span>
                            <Slct
                              isDisabled={!!isWaitingResponse}
                              options={[
                                {
                                  value: null,
                                  label: "-- Todas --",
                                },
                              ].concat(categories)}
                              placeholder="..."
                              value={filter?.category_id}
                              onChange={__ev => {
                                setfilter({
                                  ...filter,
                                  category_id: __ev.value,
                                  resource_id: null,
                                });
                              }}
                            />
                          </Col>
                          <Col sm={6}>
                            <span>Recurso</span>
                            <Slct
                              isDisabled={!!isWaitingResponse}
                              options={[
                                {
                                  value: null,
                                  label: "-- Todos --",
                                },
                              ].concat(
                                categories?.find(__category => __category?.value === filter?.category_id)?.resources ||
                                  [],
                              )}
                              placeholder="..."
                              value={filter?.resource_id}
                              onChange={__ev => {
                                setfilter({
                                  ...filter,
                                  resource_id: __ev.value,
                                });
                              }}
                            />
                          </Col>
                        </Row>
                        {!isWaitingResponse && (
                          <Row className="mt-3">
                            <Col>
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => {
                                  applyFilter();
                                }}
                              >
                                Aplicar Filtro
                              </Button>
                              <Button
                                color="grey"
                                size="sm"
                                onClick={() => {
                                  applyFilter({});
                                }}
                              >
                                Limpar Filtro
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </Accordion2.Body>
                    </Accordion2.Item>
                  </Accordion2>
                  {!isLoadingAttendances ? (
                    <>
                      <Row className="mt-4">
                        <Col>
                          <AttendanceTable
                            query={query}
                            filter={filter}
                            applyFilter={applyFilter}
                            attendances={attendances}
                            setattendances={setattendances}
                          />
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <Loading className="mt-2" />
                  )}
                </SubContent>
              </Col>
              <Col sm={3}>
                <SubContent className="p-0">
                  <SidebarAtendimento count={attendances?.filter_count} setFilter={applyFilter} filter={filter} />
                </SubContent>
              </Col>
            </Row>
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}
      </Main>
    </>
  );
}
